import Vue from 'vue'
import Router from 'vue-router'
import Account from '../components/Account/Index.vue'
import Login from '../components/Login.vue'
import store from '../store'
import SalesOrder from '../components/SalesOrder/Index.vue'
import History from '../components/History/Index.vue'
import Billing from '../components/Billing/Index.vue'
import BillingShow from '../components/Billing/Show.vue'
import BillingList from '../components/BillingList/Index.vue'
import BillingListShow from '../components/BillingList/Show.vue'
import Timeentry from '../components/CreateTimeEntry/Index.vue'
import RegieIndex from '../components/Regie/Index.vue'
import Regie from '../components/Regie/Create.vue'
import Planner from '../components/Planner/Index.vue'
import Sign from '../components/Regie/Sign.vue'
import Settings from '../components/Settings/Index.vue'
import Calls from '../components/Service/Call/Index.vue'
import CallsCreate from '../components/Service/Call/Create.vue'
import Customerhistory from '../components/Service/Customerhistory.vue'
import Teammeetings from '../components/Teammeetings/Index.vue'
import TeammeetingsShow from '../components/Teammeetings/Show.vue'
import MaterialOrder from '../components/MaterialOrder/Create.vue'
import Cookies from 'js-cookie'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem('access_token')) {
    Cookies.set('access_token', localStorage.getItem('access_token'), { expires: 180 })
  }
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'SalesOrder',
      component: SalesOrder,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/timeentry',
      name: 'timeentry',
      component: Timeentry,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/history',
      name: 'History',
      component: History,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/regie',
      name: 'RegieIndex',
      component: RegieIndex,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/regie/create',
      name: 'RegieCreate',
      component: Regie,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/regie/:id/edit',
      name: 'RegieEdit',
      component: Regie,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/regie/:id/sign',
      name: 'RegieSign',
      component: Sign,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/billing',
      name: 'Billing',
      component: Billing,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/billing/:id',
      name: 'BillingShow',
      component: BillingShow,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/billinglist',
      name: 'BillingList',
      component: BillingList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/billinglist/:id',
      name: 'BillingListShow',
      component: BillingListShow,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/calls',
      name: 'Calls',
      component: Calls,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/customerhistory',
      name: 'Customerhistory',
      component: Customerhistory,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/calls/create',
      name: 'CallsCreate',
      component: CallsCreate,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/planner',
      name: 'Planner',
      component: Planner,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/teammeetings',
      name: 'Teammeetings',
      component: Teammeetings,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/teammeetings/:id',
      name: 'TeammeetingsShow',
      component: TeammeetingsShow,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/login/:code',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/materialorder',
      name: 'Materialorder',
      component: MaterialOrder,
      beforeEnter: ifAuthenticated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js